export const debug = component => require('debug')(`skinsoft:reporter:${component}`); // tslint:disable-line no-var-requires
